<template>
  <div>
    <!-- MODALE AGGIUNTA LINK -->
    <wg-modal
      v-if="openLinkModal"
      :width="windowWidth > 700 ? '700px' : '90%'"
      @closeModal="openLinkModal = false"
    >
      <div class="wg-row" slot="header" style="flex-wrap:nowrap;align-items:center;">
        <div class="com-anm22-app-text-xl" slot="header">{{ $anm22.strLang(lang, 'Add new link', 'Aggiungi link') }}</div>
      </div>
      <add-link :element="task" @save="saveLink" slot="body"></add-link>
    </wg-modal>
    <!-- MODALE DATE-PICKER INIZIO-->
    <wg-modal
      v-if="openPickerStart"
      :portal="true"
      :width="windowWidth > 700 ? '400px' : '90%'"
      @closeModal="openPickerStart = false"
    >
      <div slot="body">
        <world-date-picker  :from="task.startDate != '' ? task.startDate : $moment.utc($moment()).unix()" @customFunction="setStart"></world-date-picker>
      </div>
    </wg-modal>
    <!-- MODALE CONSEGNA STIMATA/CONSEGNA EFFETTIVA -->
    <wg-modal
      v-if="deliveryPicker"
      :portal="true"
      :width="windowWidth > 700 ? '400px' : '90%'"
      @closeModal="deliveryPicker = false"
    >
      <div slot="body">
        <world-date-picker
          v-if="isExpected"
          :from="task.expectedEndDate != '' ? task.expectedEndDate : $moment.utc($moment()).unix()"
          @customFunction="setExpectedEndDate"
        ></world-date-picker>
        <world-date-picker
          v-else
          :from="task.actualEndDate != '' ? task.actualEndDate : $moment.utc($moment()).unix()"
          @customFunction="setActualEndDate"
        ></world-date-picker>
      </div>
    </wg-modal>
    <!-- PAGINA PRINCIPALE -->
    <div style="position:relative;">
      <!-- Selezione rapida di status e priorità -->
      <div class="wg-row wg-p-xs-5" style="align-items:center; gap: 12px;">
        <!-- Visualizzazione desktop -->
        <div class="wg-col wg-xs-12 wg-fx-sm-6 wg-fx-lg-7 wg-fx-xl-8">
          <div class="wg-row" style="align-items:center;flex-wrap:nowrap;">
            <div class="com-anm22-app-text-xl">{{ $anm22.strLang(lang, 'Status', 'Stato') }}</div>
            <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
            <div class="wg-row" style="position:relative;max-width:240px;">
              <template v-if="canEdit">
                <button
                  class="status-select-button"
                  :style="{ backgroundColor: getStatusColor(task.status) }"
                  @click="showStatusOptions = !showStatusOptions"
                >
                  <div class="wg-row status-select-button-row">
                    <div
                      class="com-anm22-app-text-l"
                    >{{ $anm22.tableClasses.taskStatus().getById(task.status)[lang] }}</div>
                    <img
                      class="com-anm22-app-img-fixed-height-s"
                      style="position:absolute;right:10px;height:14px"
                      :src="$anm22.icons.getWorldIcon('arrowDown')"
                    />
                  </div>
                </button>
                <div v-show="showStatusOptions" class="wg-row status-select-list">
                  <div
                    v-for="(status,key,index) in $anm22.tableClasses.taskStatus().getAll()"
                    :key="'status-'+index"
                    v-if="key != task.status"
                    class="wg-row status-select-list-item"
                    @click="changeStatus(Number(key));showStatusOptions = false;"
                  >
                    <div
                      class="wg-row com-anm22-app-text-m status-select-list-item-text"
                      :style="{backgroundColor: getStatusColor(Number(key))}"
                    >{{ status[lang] }}</div>
                  </div>
                </div>
              </template>
              <button
                v-else
                class="status-select-button"
                :style="{ cursor: 'default', backgroundColor: getStatusColor(task.status) }"
              >
                <div class="wg-row status-select-button-row">
                  <div
                    class="com-anm22-app-text-l"
                  >{{ $anm22.tableClasses.taskStatus().getById(task.status)[lang] }}</div>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-fx-sm-6 wg-fx-lg-5 wg-fx-xl-4">
          <div class="wg-row" style="align-items:center;flex-wrap:nowrap;max-width:290px;">
            <div class="com-anm22-app-text-xl">{{ $anm22.strLang(lang, 'Priority', 'Priorità') }}</div>
            <div style="position:relative;">
            <img @click="showHelpPriority =! showHelpPriority" class="com-anm22-app-img-s" style="margin-left:5px;opacity:0.6;cursor:pointer;" :src="$anm22.icons.getWorldIcon('helpIcon')">
            <world-help-label v-if="showHelpPriority" @closeLabel="showHelpPriority = false" :position="'right'" :text="'Imposta il livello d’urgenza del task'"></world-help-label>
          </div>
            <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
            <div class="wg-row" style="justify-content:space-around;">
              <img
                v-for="(p,key,index) in $anm22.tableClasses.taskPriority().getAll()"
                :key="'status-'+index"
                class="com-anm22-app-img-fixed-height-l"
                :style="{
                  padding: '5px 0',
                  cursor: canEdit ? 'pointer' : 'default', 
                  boxShadow: task.priority == key ? '0 0 0 2px #ccc' : '',
                  borderRadius: '4px',
                  boxSizing: 'border-box'
                }"
                :src="getPriorityIcon(Number(key))"
                :title="p[lang]"
                @click="canEdit ? changePriority(Number(key)) : ''"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <!-- Task properties -->
      <div class="wg-row" style="padding:5px; gap: 12px;">
        <div class="wg-col wg-xs-12 wg-fx-sm-6 wg-fx-lg-7 wg-fx-xl-8" style="padding-right:10px;">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Description', 'Descrizione') }}</div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="quill-wrapper">
            <quill-editor
              v-model="task.description"
              :options="editorOptions"
              :disabled="!canEdit"
              @ready="onEditorReady"
              @change="saveTask"
            ></quill-editor>
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-fx-sm-6 wg-fx-lg-5 wg-fx-xl-4">
          <div
            class="wg-row"
            style="align-items:center;justify-content:space-between;flex-wrap:nowrap;"
          >
            <div class="wg-col wg-xs-6">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Start', 'Inizio') }}</div>
            </div>
            <div class="wg-col wg-xs-6" style="position:relative;">
              <template v-if="canEdit">
                <div 
                  @click="openPickerStart =! openPickerStart;"
                  class="input-date-picker-label"
                  style="margin-top:5px;">
                  {{ (task.startDate != "")?$moment.unix(task.startDate).format('DD-MM-YYYY'):"-" }}
                </div>
                <img v-if="task.startDate != ''"
                  class="com-anm22-app-img-fixed-height-s reset-date"
                  :src="$anm22.icons.getWorldIcon('deleteBlack')"
                  @click="resetStartDate();"
                />
              </template>
              <template v-else>
                <div 
                  class="input-date-picker-label"
                  style="margin-top:5px;">
                {{ (task.startDate != "")?$moment.unix(task.startDate).format('DD-MM-YYYY'):"-" }}
                </div>
              </template>
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div
            class="wg-row"
            style="align-items:center;justify-content:space-between;flex-wrap:nowrap;"
          >
            <div class="wg-col wg-xs-5">
              <div
                style="display:inline-block;vertical-align:middle;"
                class="com-anm22-app-text-m"
              >{{ $anm22.strLang(lang, 'Time estimate', 'Tempo stimato') }}</div>
            <div style="position:relative;display:inline-block;vertical-align:middle;">
              <img @click="showHelpExpectedHours =! showHelpExpectedHours" class="com-anm22-app-img-s" style="margin-left:5px;opacity:0.6;cursor:pointer;" :src="$anm22.icons.getWorldIcon('helpIcon')">
              <world-help-label v-if="showHelpExpectedHours" @closeLabel="showHelpExpectedHours = false" :position="'right'" :text="'Imposta il tempo presunto di realizzo del task'"></world-help-label>
            </div>
            </div>
            <div class="wg-col wg-xs-6">
              <template v-if="canEdit">
                <div
                  v-show="!editExpectedWorkHours"
                  class="com-anm22-app-text-m display-flex hidden-input"
                  @click="editExpectedWorkHours = true;$nextTick(() => $refs.ewhInput.focus())"
                >{{ expectedWorkHours | hoursToText($anm22, lang) }}</div>
                <input
                  v-show="editExpectedWorkHours"
                  ref="ewhInput"
                  class="com-anm22-app-input-text"
                  type="text"
                  :placeholder="expectedWorkHours | hoursToExp"
                  :value="expectedWorkHours | hoursToExp"
                  @blur="editExpectedWorkHours = false"
                  @change="expectedWorkHours = $event.target.value"
                />
              </template>
              <div
                v-else
                class="com-anm22-app-text-m display-flex"
              >{{ expectedWorkHours | hoursToText($anm22, lang) }}</div>
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div
            class="wg-row"
            style="align-items:center;justify-content:space-between;flex-wrap:nowrap;"
          >
            <div class="wg-col wg-xs-6">
              <div
                class="com-anm22-app-text-m"
                style="display:inline-block;vertical-align:middle;"
              >{{ $anm22.strLang(lang, 'Expected end', 'Consegna stimata') }}</div>
              <div style="position:relative;display:inline-block;vertical-align:middle;">
                <img @click="showHelpexpectedEndDate =! showHelpexpectedEndDate" class="com-anm22-app-img-s" style="margin-left:5px;opacity:0.6;cursor:pointer;" :src="$anm22.icons.getWorldIcon('helpIcon')">
                <world-help-label  v-if="showHelpexpectedEndDate" @closeLabel="showHelpexpectedEndDate = false" :position="'right'" :text="'Imposta la data di consegna del task'"></world-help-label>
            </div>
            </div>
            <div class="wg-col wg-xs-6" style="position:relative;">
              <template v-if="canEdit">
                <div 
                  @click="deliveryPicker =! deliveryPicker;isExpected = true;"
                  class="input-date-picker-label"
                  style="margin-top:5px;">
                {{ (task.expectedEndDate != "")?$moment.unix(task.expectedEndDate).format('DD-MM-YYYY'):"-" }}
                </div>
                <img v-if="task.expectedEndDate != ''"
                  class="com-anm22-app-img-fixed-height-s reset-date"
                  :src="$anm22.icons.getWorldIcon('deleteBlack')"
                  @click="resetExpectedDate()"
                />
              </template>
              <template v-else>
                <div  
                  class="input-date-picker-label"
                  style="margin-top:5px;">
                {{ (task.expectedEndDate != "")?$moment.unix(task.expectedEndDate).format('DD-MM-YYYY'):"-" }}
                </div>
              </template>
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div
            class="wg-row"
            style="align-items:center;justify-content:space-between;flex-wrap:nowrap;"
          >
            <div class="wg-col wg-xs-6">
              <div
                style="display:inline-block;vertical-align:middle;"
                class="com-anm22-app-text-m"
              >{{ $anm22.strLang(lang, 'Actual time', 'Tempo effettivo') }}</div>
              <div style="position:relative;display:inline-block;vertical-align:middle;">
                <img @click="showHelpActualWorkHours =! showHelpActualWorkHours" class="com-anm22-app-img-s" style="margin-left:5px;opacity:0.6;cursor:pointer;" :src="$anm22.icons.getWorldIcon('helpIcon')">
                <world-help-label v-if="showHelpActualWorkHours" @closeLabel="showHelpActualWorkHours = false" :position="'right'" :text="'Ogni volta che lavori sul task imposta quanto tempo hai lavorato in modo da avere il tempo reale di realizzo'"></world-help-label>
            </div>
            </div>
            <div class="wg-col wg-xs-6">
              <template v-if="canEdit">
                <div
                  v-show="!editActualWorkHours"
                  class="com-anm22-app-text-m display-flex hidden-input"
                  @click="editActualWorkHours = true;$nextTick(() => $refs.awhInput.focus())"
                >{{ actualWorkHours | hoursToText($anm22, lang) }}</div>
                <input
                  v-show="editActualWorkHours"
                  ref="awhInput"
                  class="com-anm22-app-input-text add-input"
                  type="text"
                  placeholder="hh:mm"
                  value
                  @blur="editActualWorkHours = false"
                  @change="actualWorkHours = $event.target.value"
                />
              </template>
              <div
                v-else
                class="com-anm22-app-text-m display-flex"
              >{{ actualWorkHours | hoursToText($anm22, lang) }}</div>
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div
            class="wg-row"
            style="align-items:center;justify-content:space-between;flex-wrap:nowrap;"
          >
            <div class="wg-col wg-xs-6">
              <div
                class="com-anm22-app-text-m"
              >{{ $anm22.strLang(lang, 'Actual end', 'Consegna effettiva') }}</div>
            </div>
            <div class="wg-col wg-xs-6" style="position:relative;">
              <template v-if="canEdit">
                <div 
                  @click="deliveryPicker =! deliveryPicker;isExpected = false;"
                  class="input-date-picker-label"
                  style="margin-top:5px;">
                {{ (task.actualEndDate != "")?$moment.unix(task.actualEndDate).format('DD-MM-YYYY'):"-" }}
                </div>
                <img v-if="task.actualEndDate != ''"
                  class="com-anm22-app-img-fixed-height-s reset-date"
                  :src="$anm22.icons.getWorldIcon('deleteBlack')"
                  @click="resetActualEndDate()"
                />
              </template>
              <template v-else>
                <div 
                    class="input-date-picker-label"
                    style="margin-top:5px;">
                  {{ (task.actualEndDate != "")?$moment.unix(task.actualEndDate).format('DD-MM-YYYY'):"-" }}
                </div>
              </template>
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="com-anm22-horizontal-line-light"></div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <!-- Gestione staff del task -->
          <div class="wg-row">
            <div class="wg-row" style="align-items:center;">
              <div class="com-anm22-app-text-l">{{ $anm22.strLang(lang, 'Users', 'Utenti') }}</div>
              <!-- Pulsante per mostrare la "scheda" di gestione degli utenti -->
              <img
                v-if="canEdit"
                :src="$anm22.icons.getWorldIcon('multiUser')"
                class="com-anm22-app-img-fixed-height-m"
                style="cursor:pointer;margin-left:10px;"
                @click="showUserPage = !showUserPage"
              />
              <div style="position:relative;">
                <img @click="showHelpUsers =! showHelpUsers" class="com-anm22-app-img-s" style="margin-left:5px;opacity:0.6;cursor:pointer;" :src="$anm22.icons.getWorldIcon('helpIcon')">
                <world-help-label  v-if="showHelpUsers" @closeLabel="showHelpUsers = false" :position="'right'" :text="'Imposta a chi vuoi assegnare il progetto, in alternativa imposta il reparto'"></world-help-label>
              </div>
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <!-- Lista utenti -->
            <div class="wg-row" style="min-height:22px;">
              <div
                v-if="!task.users || task.users.length === 0"
                class="com-anm22-app-text-l"
              >{{ $anm22.strLang(lang, 'No users', 'Nessun utente') }}</div>
              <template v-else>
                <!-- Anteprima utenti -->
                <div
                  v-for="(user,index) in taskUsers"
                  :key="'u'+index"
                  class="wg-col wg-xs-12 wg-sm-6"
                  style="display:flex;align-items:center;"
                >
                  <!-- <img
                    v-if="user.image !== '' || (user.fbId && user.fbId !== '' && user.fbId != 0)"
                    :src="$anm22.getObjIcon(user, 'userDefault')"
                    :title="user.name + ' ' + user.surname"
                    class="com-anm22-app-img-fixed-height-m com-anm22-round"
                    style="margin-right:5px;"
                  >
                  <div
                    v-else
                    class="project-list-user"
                    :title="user.name + ' ' + user.surname"
                    style="width:22px;height:22px;border-radius:11px;padding-top:4px;margin:0 5px 0 0;"
                  >
                    {{ user.name.substring(0,1) + user.surname.substring(0,1) }}
                  </div>-->
                  <div style="min-width:22px;width:22px;height:22px;margin-right:2px;">
                    <world-object-icon :type="'user'" :obj="user" :isImg="true"></world-object-icon>
                  </div>
                  <div class="com-anm22-app-text-m">{{ user.name + ' ' + user.surname }}</div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <!-- GESTIONE DIPENDENZE FS-->
        <div class="wg-row">
          <div class="wg-col wg-xs-12">
            <div
              class="com-anm22-app-text-l"
              style="font-weight:bold"
              :title="'Finish-to-Start'"
            >
              {{ $anm22.strLang(lang, 'FS dependencies', 'Dipendenze FS') }}
              <div style="position: relative; display: inline-block; vertical-align: middle;">
                <img @click="showHelpFts =! showHelpFts" class="com-anm22-app-img-s" style="margin-left:5px;opacity:0.6;cursor:pointer;" :src="$anm22.icons.getWorldIcon('helpIcon')">
                <world-help-label v-if="showHelpFts" @closeLabel="showHelpFts = false" :position="'under-right'" :text="'Aggiungi i task che devono essere completati prima che l’utente o il reparto possa iniziare questo.'"></world-help-label>
              </div>
            </div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <div class="wg-row">
              <div
                v-for="(t, index) in ftsDependencies"
                :key="'task-dep-'+index"
                :class="['display-flex', 'task-dependency']"
                :style="{backgroundColor: (t.status !== 3 ? '#ffc107' : '#01d479')}"
              >
                <div class="com-anm22-app-text-m" style="padding:'5px'">{{ t.name }}</div>
                <img
                  v-if="canEdit"
                  class="com-anm22-app-img-fixed-height-s"
                  :src="$anm22.icons.getWorldIcon('deleteBlack')"
                  style="margin-left:10px;cursor:pointer;"
                  @click="removeTaskDependency(t.idWorldTask)"
                />
              </div>
            </div>
            <div class="com-anm22-app-text-l" v-if="canEdit && !showAddDependency" style="cursor: pointer;" @click="showAddDependency = true">+ {{ $anm22.strLang(lang, 'Add dependency', 'Aggiungi dipendenza') }}</div>
          </div>
          <div v-if="showAddDependency" class="wg-col wg-xs-12">
            <div class="vertical-height-div" style="height:5px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
              <select class="com-anm22-app-select" ref="selectDependency">
                <option
                  v-for="(task, index) in tasksToAddDependency"
                  :key="'task-add-'+index"
                  :value="task.idWorldTask"
                >{{ task.name }}</option>
              </select>
              <input
                type="button"
                class="small"
                style="margin-left:10px;"
                :value="$anm22.strLang(lang, 'Add', 'Aggiungi')"
                @click="addTaskDependency"
              />
            </div>
          </div>
        </div>
        <!-- GESTIONE JOBS -->
        <div class="vertical-height-div" style="height:6px;"></div>
        <div class="wg-row">
          <div class="wg-col wg-xs-12">
            <div
              class="com-anm22-app-text-l"
              style="font-weight:bold"
            >
              {{ $anm22.strLang(lang, 'Enabled stations', 'Postazioni abilitate') }}
              <div style="position: relative; display: inline-block; vertical-align: middle;">
                <img @click="showHelpJob =! showHelpJob" class="com-anm22-app-img-s" style="margin-left:5px;opacity:0.6;cursor:pointer;" :src="$anm22.icons.getWorldIcon('helpIcon')">
                <world-help-label  v-if="showHelpJob" @closeLabel="showHelpJob = false" :position="'under-right'" :text="'Aggiungi quale reparto può iniziare il task, qualsiasi utente di quella postazione potrà assegnarsi il compito.'"></world-help-label>
              </div>
            </div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <div class="wg-row">
              <div
                v-for="(job, index) in taskJobs"
                :key="'task-job-'+index"
                :class="['display-flex', 'task-dependency']"
                style="border:1px solid #ddd;"
              >
                <div
                  class="com-anm22-app-text-m"
                  style="padding:'5px'"
                >{{ $anm22.strLang(lang, job.en, job.it) }}</div>
                <img
                  v-if="canEdit"
                  class="com-anm22-app-img-fixed-height-s"
                  :src="$anm22.icons.getWorldIcon('deleteBlack')"
                  style="margin-left:10px;cursor:pointer;"
                  @click="removeTaskJob(job.id)"
                />
              </div>
            </div>
            <div class="com-anm22-app-text-l" v-if="canEdit && !showAddJobs" style="cursor: pointer;" @click="showAddJobs = true">+ {{ $anm22.strLang(lang, 'Add dependency', 'Aggiungi dipendenza') }}</div>
          </div>
          <div v-if="showAddJobs" class="wg-col wg-xs-12">
            <div class="vertical-height-div" style="height:5px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
              <select class="com-anm22-app-select" ref="selectJob">
                <option
                  v-for="(job, index) in projectJobs"
                  :key="'job-add-'+index"
                  :value="job.id"
                >{{ $anm22.strLang(lang, job.en, job.it) }}</option>
              </select>
              <input
                type="button"
                class="small"
                style="margin-left:10px;"
                :value="$anm22.strLang(lang, 'Add', 'Aggiungi')"
                @click="addTaskJob"
              />
            </div>
          </div>
        </div>
        <!-- GESTIONE LINK -->
        <template v-if="!project.developers.includes(474)">
          <div class="vertical-height-div" style="height:6px;"></div>
          <div class="wg-row">
            <div class="wg-col wg-xs-12 com-anm22-app-text-l" style="font-weight:bold">
              {{ $anm22.strLang(lang, 'Links and attachments', 'Collegamenti e allegati') }}
            </div>
            <div class="widgets-box com-anm22-app-custom-scroll">
              <links :isModal="true" :links="task.links" @removeLink="deleteTaskLink"></links>
              <div class="display-flex link-buttons" style="align-items:center;flex-wrap:nowrap;">
                <div class="wg-row icons">
                  <div class="icon-div">
                    <img
                      class="com-anm22-app-img-fixed-height-l" 
                      style="padding:5px;height:100%;"
                      :title="$anm22.strLang(lang, 'Add link', 'Aggiungi link')"
                      :src="$anm22.icons.getWorldIcon('link')"
                      @click="openLinkModal = true"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="wg-row" style="margin-top:5px;height:10px;">
        <template v-if="saving">
          <vue-simple-spinner size="small" :line-fg-color="appColor" />
          <div
            class="com-anm22-app-text-l"
            style="margin-left:10px;"
          >{{ $anm22.strLang(lang, 'Saving...', 'Salvataggio...') }}</div>
        </template>
      </div>
      <!-- PAGINA GESTIONE UTENTI -->
      <div v-if="canEdit" :class="['wg-row', 'slider', sliderClass]" style="background-color:#fff;">
        <div class="wg-row" style="align-items:center;">
          <img
            class="com-anm22-app-img-fixed-height-m"
            style="margin-right:5px;cursor:pointer;"
            :src="$anm22.icons.getWorldIcon('back')"
            @click="showUserPage = !showUserPage"
          />
          <div
            class="com-anm22-app-text-xl"
          >{{ $anm22.strLang(lang, 'Users assigned', 'Utenti assegnati') }}</div>
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <div
          class="com-anm22-app-text-m"
        >{{ $anm22.strLang(lang, 'Type to add new users', 'Digita per aggiungere un utente') }}</div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <!-- search bar with list -->
        <!-- ONLINE -->
        <wg-search
          v-if="!offline"
          :placeholder="$anm22.strLang(lang, 'User', 'Utente')"
          :url="'user/getByNameInDevelopers'"
          :clickFn="addUser"
          :debounceTime="1000"
          :filters="searchFilters"
          :attachedData="{projectId: task.project}"
        ></wg-search>
        <!-- OFFLINE -->
        <wg-search
          v-else
          :mode="'offline'"
          :placeholder="$anm22.strLang(lang, 'User', 'Utente')"
          :searchFn="searchUsers"
          :clickFn="addUser"
          :debounceTime="1000"
          :filters="searchFilters"
        ></wg-search>
        <!-- List of users -->
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" v-if="task.users && task.users.length !== 0">
          <div
            class="wg-row"
            style="align-items:center;"
            v-for="(u, index) in taskUsers"
            :key="'ug-' + index"
          >
            <div style="min-width:35px;width:35px;height:35px;margin-right:2px;">
              <world-object-icon :type="'user'" :obj="u" :isImg="true"></world-object-icon>
            </div>
            <div>
              <div
                class="com-anm22-app-text-l"
                style="font-weight:bold;"
              >{{ u.name + ' ' + u.surname }}</div>
              <div class="vertical-height-div" style="height:2px;"></div>
              <div
                class="display-flex"
                style="flex-wrap:nowrap;align-items:center;cursor:pointer;"
                @click="removeUser(u.idWorldUser)"
              >
                <img
                  class="com-anm22-app-img-fixed-height-s"
                  :src="$anm22.icons.getWorldIcon('deleteBlack')"
                />
                <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
                <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Remove', 'Rimuovi') }}</div>
              </div>
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import WorldDatePicker from "../../../../../world/spa/components/WorldDatePicker.vue";
import WorldHelpLabel from "../../../../../world/spa/components/WorldHelpLabel.vue";
import AddLink from  "../../../../../world/spa/components/WorldAddLink.vue";
import Links from  "../../../../../world/spa/components/WorldLinks.vue";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

export default {
  components: {
    "vue-simple-spinner": Spinner,
    WorldDatePicker,
    WorldHelpLabel,
    AddLink,
    Links,
    quillEditor
  },
  props: {
    taskId: [Number, String]
  },
  data() {
    return {
      deliveryPicker: false,
      isExpected: false,
      openPickerStart: false,
      loading: true,
      saving: false,
      showStatusOptions: false,
      showUserPage: false,
      editExpectedWorkHours: false,
      editActualWorkHours: false,
      showHelpPriority: false,
      showHelpExpectedHours: false,
      showHelpexpectedEndDate: false,
      showHelpActualWorkHours: false,
      showHelpUsers: false,
      showHelpFts: false,
      showHelpJob: false,
      openLinkModal: false,
      deleteMode: false,
      showAddDependency: false,
      showAddJobs: false,
      editorOptions: {
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", 'code-block', 'image', "clean"]
          ]
        }
      }
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      appColor: state => state.config.appColor,
      windowWidth: state => state.windowWidth,
      offline: state => state.offline.isOffline
    }),
    sliderClass() {
      return this.showUserPage ? "open" : "";
    },
    project() {
      return this.$store.getters["projects/get"](this.task.project);
    },
    task() {
      return this.$store.getters["tasks/get"](this.taskId);
    },
    userPermission() {
      return this.$store.getters["employments/getPermByProject"](this.project);
    },
    licenses() {
      return this.$store.getters["employments/getByUser"](this.user.idWorldUser)
        .filter(e => this.project.developers.includes(e.work))
        .map(e => this.$store.getters["licenses/getByWork"](e.work))
        .filter(l => l);
    },
    canEdit() {
      return this.licenses
        .filter(
          l =>
            l.config.tasks &&
            l.config.tasks.tasks &&
            l.config.tasks.tasks["edit-rules"]
        )
        .reduce(
          (result, l) =>
            result &&
            this.$anm22[l.config.tasks.tasks["edit-rules"]](this, this.task),
          true
        );
    },
    //Filtri per l'aggiunta di utenti al task
    searchFilters() {
      return [user => !this.task.users.includes(user.id)];
    },
    /* Seleziono i task di questo progetto che ancora non sono in dipendenza */
    tasksToAddDependency() {
      return this.$store.getters["tasks/getByProject"](
        this.task.project
      ).filter(
        t =>
          !this.task.fts.includes(t.idWorldTask) &&
          t.idWorldTask !== this.task.idWorldTask
      );
    },
    ftsDependencies() {
      return this.task.fts.map(id => this.$store.getters["tasks/get"](id));
    },
    projectJobs() {
      const project = this.$store.getters["projects/get"](this.task.project);
      const licenses = project.developers
        .map(w => this.$store.getters["licenses/get"](w))
        .filter(l => l);
      return licenses.reduce(
        (acc, license) =>
          acc.concat(
            license.config && license.config.tasks && license.config.tasks.jobs
          ),
        []
      );
    },
    taskJobs() {
      return this.task.jobs.map(taskJob =>
        this.projectJobs.find(j => j.id === taskJob)
      );
    },
    startDate: {
      get() {
        if (this.task.startDate !== "") {
          return this.$moment
            .unix(this.task.startDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function(newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.task.startDate = "";
          this.saveTask();
        } else if (ts) {
          this.task.startDate = ts;
          this.saveTask();
        }
      }, 1000)
    },
    expectedWorkHours: {
      get() {
        return this.task.expectedWorkHours;
      },
      set(newVal) {
        const val = this.parseTimeString(newVal);
        if (val !== null) {
          this.task.expectedWorkHours = val >= 0 ? val : 0;
          this.saveTask();
        }
        this.editExpectedWorkHours = false;
      }
    },
    actualWorkHours: {
      get() {
        return this.task.actualWorkHours;
      },
      set(newVal) {
        const val = this.parseTimeString(newVal);
        if (val !== null) {
          this.task.actualWorkHours =
            this.task.actualWorkHours + val >= 0
              ? this.task.actualWorkHours + val
              : 0;
          this.saveTask();
        }
        this.$nextTick(() => (this.$refs.awhInput.value = ""));
        this.editActualWorkHours = false;
      }
    },
    expectedEndDate: {
      get() {
        if (this.task.expectedEndDate !== "") {
          return this.$moment
            .unix(this.task.expectedEndDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function(newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.task.expectedEndDate = "";
          this.saveTask();
        } else if (ts) {
          this.task.expectedEndDate = ts;
          this.saveTask();
        }
      }, 2000)
    },
    actualEndDate: {
      get() {
        if (this.task.actualEndDate !== "") {
          return this.$moment
            .unix(this.task.actualEndDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function(newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.task.actualEndDate = "";
          this.saveTask();
        } else if (ts) {
          this.task.actualEndDate = ts;
          this.saveTask();
        }
      }, 2000)
    },
    taskUsers() {
      if (this.task.users) {
        return this.task.users.map(u => this.$store.getters["users/get"](u));
      } else {
        return [];
      }
    }
  },
  methods: {
    setStart(newDate) {
      let ts = this.$moment.utc(newDate).unix();
      if (isNaN(ts)) {
        this.task.startDate = "";
        this.saveTask();
      } else if (ts) {
        this.task.startDate = ts;
        this.saveTask();
      }
      // this.startDate = newDate;
      this.openPickerStart = false;
    },
    setExpectedEndDate(newDate) {
      let ts = this.$moment.utc(newDate).unix();
      if (isNaN(ts)) {
        this.task.expectedEndDate = "";
        this.saveTask();
      } else if (ts) {
        this.task.expectedEndDate = ts;
        this.saveTask();
      }
      this.deliveryPicker = false;
    },
    setActualEndDate(newDate) {
      let ts = this.$moment.utc(newDate).unix();
      if (isNaN(ts)) {
        this.task.actualEndDate = "";
        this.saveTask();
      } else if (ts) {
        this.task.actualEndDate = ts;
        this.saveTask();
      }
      this.deliveryPicker = false;
    },
    resetStartDate() {
      this.task.startDate = '';
      this.saveTask();
    },
    resetExpectedDate() {
      this.task.expectedEndDate = '';
      this.saveTask();
    },
    resetActualEndDate() {
      this.task.actualEndDate = '';
      this.saveTask();
    },
    getStatusColor(id) {
      switch (id) {
        case 1:
          return "#bdbdbd";
        case 2:
          return "#ffeb3b";
        case 3:
          return "#01d479";
      }
    },
    getPriorityIcon(id) {
      switch (id) {
        case 1:
          return this.$anm22.icons.getWorldIcon("priorityLowest");
        case 2:
          return this.$anm22.icons.getWorldIcon("priorityLow");
        case 3:
          return this.$anm22.icons.getWorldIcon("priorityMedium");
        case 4:
          return this.$anm22.icons.getWorldIcon("priorityHigh");
        case 5:
          return this.$anm22.icons.getWorldIcon("priorityHighest");
      }
    },
    changeStatus(statusId) {
      let callback = async () => {};
      const old = this.task.status;
      this.task.status = statusId;
      // Se il task passa da in attesa a in corso o completato e non ho alcuno sviluppatore, metto me stesso
      if (
        old === 1 &&
        (this.task.status === 2 || this.task.status === 3) &&
        this.task.users.length === 0
      ) {
        // this.task.users.push(this.user.idWorldUser);
        callback = async () => await this.addUser(this.user.idWorldUser);
      }
      //Task completato, inserisco la data di consegna se non è già presente
      if (this.task.status === 3 && this.task.actualEndDate === "") {
        this.task.actualEndDate = this.$moment.utc().unix();
      }
      // Se il task viene messo in corso o completato e non c'è una data di inizio impostata, la applico
      if ((this.task.status === 2 || this.task.status === 3) && this.task.startDate === "") {
        this.task.startDate = this.$moment.utc().unix();
      }
      this.saveTask(callback);
    },
    changePriority(p) {
      this.task.priority = p;
      this.saveTask();
    },
    async addTaskDependency() {
      const taskToAdd = Number.parseInt(this.$refs.selectDependency.value);
      if (!isNaN(taskToAdd)) {
        try {
          const response = await this.$http.post("task/addDependency", {
            projectId: this.task.project,
            taskA: taskToAdd,
            taskB: this.task.idWorldTask
          }, {
            withCredentials: true
          });
          this.$store.dispatch("tasks/update", {
            vlf: this.$vlf("tasks"),
            objs: response.data.tasks
          });
          this.showAddDependency = false;
        } catch (e) {
          this.task.fts.push(taskToAdd);
          await Promise.all([
            this.$store.dispatch("tasks/update", {
              vlf: this.$vlf("tasks"),
              objs: [this.task]
            }),
            this.$store.dispatch("offline/saveSyncTuple", {
              _vue: this,
              _class: "WorldTask",
              _table: "tasks",
              mode: "edit",
              type: "obj",
              obj: this.task
            })
            // this.$anm22.saveSyncTuple(this, 'WorldTask', 'edit', this.task)
          ]);
        }
      }
    },
    async removeTaskDependency(taskId) {
      try {
        const response = await this.$http.post("task/removeDependency", {
          projectId: this.task.project,
          taskA: taskId,
          taskB: this.task.idWorldTask
        }, {
          withCredentials: true
        });
        this.$store.dispatch("tasks/update", {
          vlf: this.$vlf("tasks"),
          objs: response.data.tasks
        });
      } catch (e) {
        const index = this.task.fts.indexOf(taskId);
        if (-1 !== index) {
          this.task.fts.splice(index, 1);
          Promise.all([
            this.$store.dispatch("tasks/update", {
              vlf: this.$vlf("tasks"),
              objs: [this.task]
            }),
            this.$store.dispatch("offline/saveSyncTuple", {
              _vue: this,
              _class: "WorldTask",
              _table: "tasks",
              mode: "edit",
              type: "obj",
              obj: this.task
            })
            // this.$anm22.saveSyncTuple(this, 'WorldTask', 'edit', this.task)
          ]);
        }
      }
    },
    async addTaskJob() {
      const jobId = this.$refs.selectJob.value;
      try {
        const response = await this.$http.post("task/addJob", {
          projectId: this.task.project,
          task: this.task.idWorldTask,
          job: jobId
        }, {
          withCredentials: true
        });
        this.$store.dispatch("tasks/update", {
          vlf: this.$vlf("tasks"),
          objs: response.data.tasks
        });
        this.showAddJobs = false;
      } catch (e) {
        this.task.jobs.push(jobId);
        Promise.all([
          this.$store.dispatch("tasks/update", {
            vlf: this.$vlf("tasks"),
            objs: [this.task]
          }),
          this.$store.dispatch("offline/saveSyncTuple", {
            _vue: this,
            _class: "WorldTask",
            _table: "tasks",
            mode: "edit",
            type: "obj",
            obj: this.task
          })
          // this.$anm22.saveSyncTuple(this, 'WorldTask', 'edit', this.task)
        ]);
      }
    },
    async removeTaskJob(jobId) {
      try {
        const response = await this.$http.post("task/removeJob", {
          projectId: this.task.project,
          task: this.task.idWorldTask,
          job: jobId
        }, {
          withCredentials: true
        });
        return this.$store.dispatch("tasks/update", {
          vlf: this.$vlf("tasks"),
          objs: response.data.tasks
        });
      } catch (e) {
        const index = this.task.jobs.indexOf(jobId);
        if (-1 !== index) {
          this.task.fts.splice(index, 1);
          Promise.all([
            this.$store.dispatch("tasks/update", {
              vlf: this.$vlf("tasks"),
              objs: [this.task]
            }),
            this.$store.dispatch("offline/saveSyncTuple", {
              _vue: this,
              _class: "WorldTask",
              _table: "tasks",
              mode: "edit",
              type: "obj",
              obj: this.task
            })
            // this.$anm22.saveSyncTuple(this, 'WorldTask', 'edit', this.task)
          ]);
        }
      }
    },
    onEditorReady(quill) {
      quill.history.clear();
      const toolbar = quill.getModule('toolbar');
      toolbar.addHandler('image', () => this.triggerImageUpload(quill));
    },
    triggerImageUpload(quill) {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      input.click();
      input.onchange = async () => {
        const file = input.files[0];
        if (!file) return;
        const formData = new FormData();
        formData.append('file', file);
        try {
          const response = await this.$http.post(
            `task/upload-file?taskId=${this.task.idWorldTask}`,
            formData,
            { withCredentials: true }
          );
          const url = response.data.url;
          const range = quill.getSelection() || { index: quill.getLength() };
          quill.insertEmbed(range.index, 'image', url);
        } catch (e) {
          console.error('Image upload failed', e);
        }
      };
    },
    saveTask: _.debounce(async function(callback) {
      this.saving = true;
      const project = { ...this.project };
      let waiting = true,
        complete = true;
      const tasks = this.$store.getters["tasks/getByProject"](
        this.project.idWorldProject
      );
      tasks.concat([this.task]).forEach(t => {
        if (t.status !== 1) {
          waiting = false;
        }
        if (t.status !== 3) {
          complete = false;
        }
      });
      if (!waiting) {
        project.status = 2;
      }
      if (complete) {
        project.status = 3;
      }
      try {
        const response = await this.$http.post("task/edit", {
          projectId: this.task.project,
          projectStatus: project.status,
          task: this.task
        }, {
          withCredentials: true
        });
        //Salvo in db locale i nuovi dati
        if (false && response.data.tasks && response.data.tasks.length == 1) {
          // Aggiorno i dati che possono essere stati modificati dal back
          this.task.users = response.data.tasks.users;
          await this.$store.dispatch("tasks/update", {
            vlf: this.$vlf("tasks"),
            objs: [this.task]
          });
        }
        if (this.project.status !== project.status) {
          this.$store.dispatch("projects/update", {
            vlf: this.$vlf("projects"),
            objs: [project]
          });
        }
      } catch (e) {
        await Promise.all([
          this.$store.dispatch("tasks/update", {
            vlf: this.$vlf("tasks"),
            objs: [this.task]
          }),
          this.$store.dispatch("offline/saveSyncTuple", {
            _vue: this,
            _class: "WorldTask",
            _table: "tasks",
            mode: "edit",
            type: "obj",
            obj: this.task
          })
          // this.$anm22.saveSyncTuple(
          //   this,
          //   "WorldTask",
          //   'edit',
          //   this.task
          // )
        ]);
        if (this.project.status !== project.status) {
          Promise.all([
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: [project]
            }),
            this.$store.dispatch("offline/saveSyncTuple", {
              _vue: this,
              _class: "WorldProject",
              _table: "projects",
              mode: "edit",
              type: "obj",
              obj: this.project
            })
            // this.$anm22.saveSyncTuple(
            //   this,
            //   "WorldProject",
            //   'edit',
            //   this.project
            // )
          ]);
        }
      } finally {
        if (typeof callback === "function") {
          await callback();
        }
        this.saving = false;
      }
    }, 2000),
    //Gestione utenti
    searchUsers(string) {
      const regexp = new RegExp(string, "i");
      return this.$store.getters["users/getAll"]
        .filter(u => {
          const fullname = u.name + " " + u.surname;
          return (
            -1 !== fullname.search(regexp) &&
            this.project.developers.reduce((res, w) => {
              return (
                res &&
                this.$store.getters["employments/get"](
                  this.user.idWorldUser + "-" + w
                ) &&
                this.$store.getters["employments/get"](u.idWorldUser + "-" + w)
              );
            }, true)
          );
        })
        .map(u => {
          const fullname = u.name + " " + u.surname;
          return {
            label: fullname,
            id: u.idWorldUser,
            img: ""
          };
        });
    },
    async addUser(userId) {
      try {
        const response = await this.$http.post("task/addUser", {
          projectId: this.task.project,
          taskId: this.task.idWorldTask,
          userId: userId
        }, {
          withCredentials: true
        });
        Promise.all([
          this.$store.dispatch("tasks/update", {
            vlf: this.$vlf("tasks"),
            objs: response.data.tasks
          }),
          this.$store.dispatch("users/update", {
            vlf: this.$vlf("users"),
            objs: response.data.users
          })
        ]);
        if (!this.project.users.includes(userId)) {
          const project = { ...this.project };
          project.users.push(userId);
          this.$store.dispatch("projects/update", {
            vlf: this.$vlf("projects"),
            objs: [project]
          });
        }
      } catch (e) {
        this.task.users.push(userId);
        this.$store.dispatch("tasks/update", {
          vlf: this.$vlf("tasks"),
          objs: [this.task]
        });
        this.$store.dispatch("offline/saveSyncTuple", {
          _vue: this,
          _class: "WorldTask",
          _table: "tasks",
          mode: "edit",
          type: "obj",
          obj: this.task
        });
        // this.$anm22.saveSyncTuple(
        //   this,
        //   "WorldTask",
        //   'edit',
        //   this.task
        // );
        if (!this.project.users.includes(userId)) {
          const project = { ...this.project };
          project.users.push(userId);
          this.$store.dispatch("projects/update", {
            vlf: this.$vlf("projects"),
            objs: [project]
          });
          this.$store.dispatch("offline/saveSyncTuple", {
            _vue: this,
            _class: "WorldProject",
            _table: "projects",
            mode: "edit",
            type: "obj",
            obj: project
          });
          // this.$anm22.saveSyncTuple(
          //   this,
          //   "WorldProject",
          //   'edit',
          //   project
          // );
        }
      }
    },
    async removeUser(userId) {
      try {
        const response = await this.$http.post("task/removeUser", {
          projectId: this.task.project,
          taskId: this.task.idWorldTask,
          userId: userId
        }, {
          withCredentials: true
        });
        this.$store.dispatch("tasks/update", {
          vlf: this.$vlf("tasks"),
          objs: response.data.tasks
        });
      } catch (e) {}
    },
    async deleteTaskLink(index) {
      let links = this.task.links;
      links.splice(index, 1);
      try {
        const response = await this.$http.post("task/links", {
          taskId: this.task.idWorldTask,
          projectId: this.task.project,
          links: links
        }, {
          withCredentials: true
        });
        this.$store.dispatch("tasks/update", {
          vlf: this.$vlf("tasks"),
          objs: response.data.tasks
        });
      } catch (e) {
        await Promise.all([
          this.$store.dispatch("tasks/update", {
            vlf: this.$vlf("tasks"),
            objs: [this.task]
          }),
          this.$store.dispatch("offline/saveSyncTuple", {
            _vue: this,
            _class: "WorldTask",
            _table: "tasks",
            mode: "edit",
            type: "obj",
            obj: this.task
          })
        ]);
      }
    },
    parseTimeString(string) {
      //Parsing della stringa per aggiornare la stima
      const regex = /-?\d*([:. ][0-5]?\d)?/;
      if (regex.test(string)) {
        let sign = "",
          hours = 0,
          minutes = 0;
        if (string.includes("-")) {
          sign = string.charAt(0);
          string = string.slice(1);
        }
        let parts = [];
        if (string.includes(":")) {
          parts = string.split(":");
          hours = parts[0];
          minutes = parts[1];
        } else if (string.includes(".")) {
          parts = string.split(".");
          hours = parts[0];
          minutes = parts[1];
        } else if (string.includes(" ")) {
          parts = string.split(" ");
          hours = parts[0];
          minutes = parts[1];
        } else {
          hours = string;
        }
        const result =
          sign !== ""
            ? Number(sign + Number(hours * 3600 + minutes * 60))
            : Number(hours * 3600 + minutes * 60);
        return result;
      } else {
        console.log("error in parsing");
        return null;
      }
    },
    async saveLink(links) {
      try {
        const response = await this.$http.post("task/links", {
          taskId: this.task.idWorldTask,
          projectId: this.task.project,
          links: links
        }, {
          withCredentials: true
        });
        this.$store.dispatch("tasks/update", {
          vlf: this.$vlf("tasks"),
          objs: response.data.tasks
        });
      } catch (e) {
        this.task.links = links;
        await Promise.all([
          this.$store.dispatch("tasks/update", {
            vlf: this.$vlf("tasks"),
            objs: [this.task]
          }),
          this.$store.dispatch("offline/saveSyncTuple", {
            _vue: this,
            _class: "WorldTask",
            _table: "tasks",
            mode: "edit",
            type: "obj",
            obj: this.task
          })
        ]);
      } finally {
        this.openLinkModal = false;
      }
    },
    editAwh() {
      this.editActualWorkHours = true;
      this.$nextTick(() => this.$refs.awhInput.focus());
    }
  },
  filters: {
    hoursToText(value, $anm22, lang) {
      let string = "";
      const hours = Math.floor(value / 3600),
        minutes = Math.floor((value % 3600) / 60);
      string += `${hours} ${$anm22.strLang(lang, "hours", "ore")}`;
      if (minutes !== 0) {
        string += `${$anm22.strLang(
          lang,
          " and ",
          " e "
        )} ${minutes} ${$anm22.strLang(lang, "minutes", "minuti")}`;
      }
      return string;
    },
    hoursToExp(value) {
      return value !== ""
        ? Math.floor(value / 3600) + ":" + Math.floor((value % 3600) / 60)
        : 0;
    }
  },
};
</script>

<style lang="scss" scoped>
.quill-wrapper {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /*
  ::v-deep .quill-editor {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  ::v-deep .ql-toolbar {
    flex-shrink: 0;
  }
  */
  ::v-deep .ql-container {
    min-height: 240px;
  }
}
.status-select-button {
  width: 100%;
  border-radius: 10px;
  border-width: 0px;
  text-decoration: none;
  outline: none !important;
  padding: 8px 0;
  cursor: pointer;
  &:hover {
    background-color: #bbb;
  }
}
.reset-date {
  opacity:0.8;
  cursor:pointer;
  right:7px;
  position:absolute;
  top:15px;
  width:11px;
}
.icon-picker {
  cursor: pointer;
  opacity: 0.7;
}

.input-date-picker-label {
  width: 100%;
  max-width: 300px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 4px;
  display: block;
  box-shadow: none;
  background-color: #eee;
  border: 1px solid #eee;
  height: 36px;
  font-size: 12px;
  cursor: pointer;
}
.status-select-button-row {
  position: relative;
  font-weight: 600;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  padding:0;
}
.status-select-button-row .com-anm22-app-text-l {
  padding:0;
  color: #263238;
}
.status-select-list {
  flex-direction: column;
  align-items: center;
  position: absolute;
  z-index: 100;
  top: 40px;
  border-radius: 10px;
  background-color: #fff;
  padding: 3px;
  box-shadow: 0 8px 10px 1px rgba(0,0,0,.1), 0 3px 14px 2px rgba(0,0,0,.1), 0 5px 5px -3px rgba(0,0,0,.1);
}
.status-select-list-item {
  align-items: center;
  padding: 3px;
  cursor: pointer;
}
.status-select-list-item-text {
  justify-content: center;
  padding: 8px;
  border-radius: 7px;
}

.slider {
  overflow-y: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 100;
  height: 0;
}

.slider.open {
  height: 100%;
}

.hidden-input {
  cursor: pointer;
  border-radius: 4px;
  padding: 5px;
  min-height: 36px;
  align-items: center;
  &:hover {
    background-color: #eee;
  }
}
.add-input {
  background-image: url("../../../../../world/libs/anm22_icons/img/icons/add.svg");
  background-repeat: no-repeat;
  background-position: 5px center;
  background-size: 12px;
  padding-left: 20px;
}
.task-dependency {
  width: fit-content;
  border-radius: 5px;
  padding: 5px;
  min-height: 36px;
  flex-wrap: nowrap;
  align-items: center;
  margin: 0 5px 5px 0;
}
.link-buttons .icons {
  align-items: center;
  font-size: 0;
  padding: 5px 0 0 0;
}
.icon-div {
  border-radius: 30px;
  width: 50px;
  height: 50px;
  border:1px solid #9999;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  padding: 5px;
  margin: 5px 10px;
  cursor: pointer;
  &:hover {
    border: none;
    background-color: #eee;
  }
}
.icon-div.desc-box {
  border: none;
  width: 40px;
  height: 40px;
  padding: 2px;
  background-color:#eee;
  &:hover {
    background-color:#ddd;
  }
}
.widgets-box {
  overflow-x:auto;
  max-width:100%;
  white-space:nowrap;
  margin: 10px 0 0 0;
}
.widgets-box > div {
  display: inline-block;
  vertical-align: middle;
}
</style>